export const getPermissionGroupsIdList = (
  permissions,
  { filter, modifier } = {}
) => {
  if (!permissions?.tenant || !permissions?.client) return [];
  // If no filter is provided, include all items
  const filterCallback = filter ?? (() => true);
  // Custom modifier to extract id, read, and write for both tenant and client groups
  const modifierCallback =
    modifier ??
    ((el) => ({
      id: el.id || el.group_id,
      read: el.read,
      write: el.write,
    }));

  return [
    ...permissions.tenant.filter(filterCallback).map(modifierCallback),
    ...permissions.client
      .map((el) => el?.groups?.filter(filterCallback).map(modifierCallback))
      .flat()
      .filter(Boolean),
  ];
};

export const mapPermissionGroups = (allPermissions, { modifier }) => {
  const modifierCallback = modifier ?? ((el) => el);

  return {
    tenant: allPermissions.tenant.map(modifierCallback),
    client: allPermissions.client.map((el) => ({
      ...el,
      groups: el?.groups.map(modifierCallback),
    })),
  };
};

export const mapPermissionGroup = (
  permissionGroup,
  { modifier, listItemModifier }
) => {
  const modifierCallback = modifier ?? ((el) => el);
  const listItemModifierCallback = listItemModifier ?? modifier ?? ((el) => el);

  return permissionGroup.map((el) => {
    const result = modifierCallback(el);
    if (result.groups) {
      result.groups = result.groups.map(listItemModifierCallback);
    }
    return result;
  });
};
